import styles from "../../../styles/Participant-Employment.module.css"
import { Checkbox } from "primereact/checkbox"
const CheckboxField = ({
  label,
  value,
  setValue,
  valueName,
  single,
  style,
  callback,
}) => {
  return (
    <div className={styles.field} style={style}>
      <div className={styles.chkbox_wrapper} style={style}>
        <div className={styles.chkbox} style={style}>
          <Checkbox
            inputId={label}
            name="category"
            className={`${styles.checkbox_design} ${styles.checkbox_border}`}
            value={value}
            onChange={(e) => {
              if (single) {
                if (valueName) {
                  setValue(valueName, e.checked)
                } else {
                  setValue(e.checked)
                }
              } else {
                const updated = { ...value, ...{ [valueName]: e.checked } }
                setValue(updated)
              }
              if (callback) {
                callback(value)
              }
            }}
            checked={single ? value : value[valueName]}
          />
          <label htmlFor={label} style={{ marginLeft: "7px" }}>
            {label}
          </label>
        </div>
      </div>
    </div>
  )
}
export default CheckboxField
